import React from 'react';

import LocalizedLink from 'components/LocalizedLink';
import logo from 'static/images/logo.png';
import logo2x from 'static/images/logo@2x.png';

const Logo = () => (
  <LocalizedLink to="/" className="gb-logo-link">
    <img src={logo} srcSet={`${logo2x} 2x`} alt="GastroBuddy" />
  </LocalizedLink>
);

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Logo.tsx